<!-- Wrapper -->
<div class="page-wrapper" id="pageWrapper">
	<router-outlet></router-outlet>

	<app-version-label></app-version-label>
</div>
